import { environments } from 'environments/environments';
import { VehicleResponseDTO } from 'models/VehicleResponseDTO';
import api from './api';

const { ENDPOINT_CONTRACTS } =
   environments

/**
 * Busca veículos na API com filtro de modelo.
 * @param modelo Termo de busca para o modelo do veículo.
 * @returns Promessa com a lista de veículos.
 */
export const getVehicles = async (
   modelo: string
): Promise<VehicleResponseDTO[]> => {
   try {

      // A API espera 'modelo' como query param, conforme sua descrição.
      const { data } = await api.get<VehicleResponseDTO[]>(`${ENDPOINT_CONTRACTS}/veiculos`, {
         params: {
            pagina: 1,
            limite: 10, // A API retorna 10, conforme o exemplo
            modelo: modelo
         }
      });
      return data;
   } catch (error) {
      console.error('Erro ao buscar veículos:', error);
      return []; // Retorna array vazio em caso de erro para não quebrar o front
   }
};